module.exports = __webpack_public_path__ + "files/6b3f2ce73ef8c947a59806ed20fd7983.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/Source-Sans-Pro-regular.woff
 ** module id = 878
 ** module chunks = 0
 **/